module.exports = __webpack_public_path__ + "static/media/cloud-sun-meatball.2c6f5381.svg";